<template src="./NaturalPersonCustomers.html"></template>
<script>
import mixins from "../../../../Mixins.js";
import moment from "moment";
import ExportReport from "@/components/export-report/ExportReport.vue";
import SearchByDate from "@/components/search-by-date/SearchByDate.vue";
import UpdateTableSize from "@/components/update-table-size/UpdateTableSize.vue"

export default {
  mixins: [mixins],
  components: { ExportReport, SearchByDate, UpdateTableSize },
  data() {
    return {
      historic: [],
      searchTotal: 0,
      currentx: 1,
      numPages: 0,
      pagination: false,
      windowWidth: 0,
      search:"",
      searchUrl:"",
      tableSize: 10,
      date: {
        initial: null,
        final: null,
      },
    };
  },
  watch: {
    currentx: function () {
      const vm = this;
      vm.getReport();
    },
  },
  mounted: function () {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  methods: {
    init() {
      const vm = this;
      vm.date.initial = moment().clone().startOf("M").format('YYYY-MM-DD');
      vm.date.final = moment().format('YYYY-MM-DD');
      vm.getReport();
    },

    getReport() {
      const vm = this;
      vm.$vs.loading();

      let page = 0;
      page = vm.currentx == 1 ? 0 : vm.currentx - 1;

      const url = vm.getPageUrl(page);
      const bearer = vm.$session.get("bearer");

      vm.axios
        .get(url, {
          headers: { Authorization: bearer },
        })
        .then(async function (response) {
          if (response.status === 200) {
            vm.historic = response.data.content;
            vm.prepareDataToExhibit(vm.historic);
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.searchTotal = response.data.totalElements;
            vm.$vs.loading.close();
          }
        }).catch( () => vm.$vs.loading.close());
    },

    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },

    updateSearchDate(date) {
      const vm = this;
      vm.currentx = 1;
      vm.date = date;
      vm.getReport();
    },

    updateTableSize(size) {
      const vm = this;
      vm.tableSize = size;
      vm.currentx = 1;
      vm.getReport();
    },

    getSearchUrl() {
      const vm = this;
      const search = vm.testNullUndefinedEmpty(vm.search)? "": "&search=" + vm.search;
      const date = vm.testNullUndefinedEmpty(vm.date) ||vm.testNullUndefinedEmpty(vm.date.initial) || vm.testNullUndefinedEmpty(vm.date.final) ? "" :
        "&initialDate=" + vm.date.initial + "&finalDate=" + vm.date.final;
      vm.searchUrl = search + date;
    },

    getPageUrl(page) {
      const vm = this;
      vm.getSearchUrl();
      return vm.$store.state.filooServer +
       "payment/get-clientespf-report?page=" + page +"&size="+ vm.tableSize + vm.searchUrl;
    },

    changeSearch(){
      const vm = this;
      vm.currentx = 1;
      vm.getReport();
    },

    prepareDataToExhibit() {
      const vm = this;
      for (let historic in vm.historic) {
        if (vm.historic[historic].dataInclusao != null) {
          vm.historic[historic].dataInclusao = moment(vm.historic[
            historic
            ].dataInclusao.split(" ")[0])
            .locale("pt-br")
            .format('DD/MM/YYYY');
        }
        if (
          vm.testNullUndefinedEmpty(
            vm.historic[historic].dataUltimoPagamento
          ) === false
        ) {
          vm.historic[historic].dataUltimoPagamento = moment(
            vm.historic[historic].dataUltimoPagamento
          )
            .locale("pt-br")
            .format('DD/MM/YYYY');
        }
        if (vm.historic[historic].status === false) {
          vm.historic[historic].status = "Inativo";
        } else {
          vm.historic[historic].status = "Ativo";
        }
        if (vm.historic[historic].tipo === false) {
          vm.historic[historic].tipo = "B2C";
        } else {
          vm.historic[historic].tipo = "B2B";
        }
        if(!vm.testNullUndefinedEmpty(vm.historic[historic].genero)) {
          vm.historic[historic].genero = vm.historic[historic].genero === "M" ?
            "Masculino" : "Feminino";
        } else {
          vm.historic[historic].genero = "Sem Registro";
        }
        if (vm.historic[historic].metodoPagamento !== null) {
          vm.historic[historic].metodoPagamento =
            vm.historic[historic].metodoPagamento;
        } else {
          vm.historic[historic].metodoPagamento = "Sem registro";
        }
        if (vm.historic[historic].valor !== null) {
          if (vm.historic[historic].valor !== '-') {
            vm.historic[historic].valor = vm.maskMoney(
              vm.historic[historic].valor
            );
          } else {
            vm.historic[historic].valor = vm.maskMoney(0);
          }
        } else {
          vm.historic[historic].valor = "Sem registro";
        }
        if (vm.historic[historic].campanha !== null) {
          vm.historic[historic].campanha = vm.historic[historic].campanha;
        } else {
          vm.historic[historic].campanha = "Sem registro";
        }
        if (vm.historic[historic].tipo !== null) {
          vm.historic[historic].tipo = vm.historic[historic].tipo;
        } else {
          vm.historic[historic].tipo = "Sem registro";
        }
        if (vm.historic[historic].cep !== null) {
          vm.historic[historic].cep = vm.historic[historic].cep;
        } else {
          vm.historic[historic].cep = "Sem registro";
        }
        if (vm.testNullUndefinedEmpty(vm.historic[historic].phone)) {
          vm.historic[historic].phone = "Sem registro";

        } else {
          vm.historic[historic].phone = vm.maskCelPhone(vm.historic[historic].phone);
        }
        if (vm.testNullUndefinedEmpty(vm.historic[historic].dataPrevistaLiberacao)) {
          vm.historic[historic].dataPrevistaLiberacao = "Nenhuma data registrada";

        } else {
          vm.historic[historic].dataPrevistaLiberacao = moment(vm.historic[historic].dataPrevistaLiberacao).locale("pt-br").format("L");
        }
      }
    },
  },
};
</script>
<style src="./NaturalPersonCustomers.css">
</style>
